import styled from '@emotion/styled';
import { Divider, Switch, notification } from 'antd';
import { useEffect, useState } from 'react';
import { MoonLoader } from 'react-spinners';
import { ProfilEntity } from '../../../../entities/profil.entity';
import { UserEntity } from '../../../../entities/utilisateur.entity';
import {
  createUtilisateurProfil,
  deleteUtilisateurProfil,
  getProfils,
} from '../network';

const Container = styled.div`
  color: black;

  .pro_name {
    color: black;
    width: 200px;
    margin-bottom: 10px;
  }
`;

export const ProfilForm = ({
  user,
  userProfils,
}: {
  user?: UserEntity;
  userProfils: ProfilEntity[];
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [profils, setProfils] = useState<ProfilEntity[]>([]);
  const [switchVal, setSwitchVal] = useState({});

  useEffect(() => {
    getProfils().then(({ data }) => {
      setProfils(data);
    });
  }, []);

  useEffect(() => {
    if (profils.length > 0) {
      let vals = {};
      for (let pro of profils) {
        vals[pro.id] = userProfils.find((upro) => upro.id === pro.id)
          ? true
          : false;
      }
      setSwitchVal(vals);
    }
    // eslint-disable-next-line
  }, [user, profils]);

  const createProfil = async (user: string, profil: string) => {
    setIsLoading(true);
    await createUtilisateurProfil({ utilisateur: user, profil: profil }).then(
      ({ statusCode, data }) => {
        setIsLoading(false);
        if (statusCode?.toString()[0] === '2') {
          notification.success({
            message: 'Succès',
            description: 'Le profil a été attribué avec succès',
          });
        } else {
          notification.info({
            message: 'Erreur',
            description: data.message,
          });
        }
      },
    );
    setIsLoading(false);
  };

  const deleteProfil = async (user: string, profil: string) => {
    setIsLoading(true);
    await deleteUtilisateurProfil({ userId: user, profilId: profil }).then(
      ({ statusCode, data }) => {
        setIsLoading(false);
        if (statusCode?.toString()[0] === '2') {
          notification.success({
            message: 'Succès',
            description: 'Le profil a été désactivé avec succès',
          });
        } else {
          notification.info({
            message: 'Erreur',
            description: data.message,
          });
        }
      },
    );
    setIsLoading(false);
  };

  return (
    <Container>
      <p>
        Attribuer des profils à :{' '}
        <b>
          {user?.nom} {user?.prenom}
        </b>
      </p>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <MoonLoader size={20} color='green' loading={isLoading} />
      </div>
      <Divider />

      {profils.map((pro) => (
        <div key={pro.id} style={{ display: 'flex' }}>
          <div className='pro_name'>{pro.nom}</div>
          <Switch
            checked={switchVal[pro.id]}
            onChange={(e) => {
              setSwitchVal({ ...switchVal, [pro.id]: e.valueOf() });
              if (user && e.valueOf() === true) {
                createProfil(user.url, pro.url);
              } else if (user && e.valueOf() === false) {
                deleteProfil(user.id, pro.id);
              }
            }}
          />
        </div>
      ))}
    </Container>
  );
};
